import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { getPatientVisits } from "../../../services/doctors";

import { useToast } from "../../../components/ui/use-toast";
import { useAuth } from "../../../contexts/auth-context";

export function usePatientsVisits({
  selectedPatient,
}: {
  selectedPatient: string | null;
}) {
  const { toast } = useToast();

  const { mobile } = useAuth();

  const {
    data: visitsInfo,
    isLoading,
    isError,
    isFetched,
  } = useQuery({
    queryKey: ["patients-visits-info", selectedPatient, mobile],
    queryFn: () => getPatientVisits(selectedPatient, mobile),
    enabled: !!mobile,
    retry: 0,
  });

  useEffect(() => {
    if (isError && selectedPatient) {
      // toast({
      //   title: "Failed to fetch doctor visits info",
      //   variant: "destructive",
      // });
    }
  }, [isError, toast, selectedPatient]);

  return { visitsInfo, isLoading, isFetched };
}
